import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { withRouter } from 'react-router-dom';

import { InlineGridField, InlineGrid } from '@components/form';

import { eventsFormHistoriesGridColumns } from '@modules/events/_eventsColumns';

const View: React.SFC<any> = ({ history }) => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>

    <Row>
      <Col md={12}>
        <InlineGridField
          component={InlineGrid}
          name="histories"
          Form={undefined}
          columns={eventsFormHistoriesGridColumns}
          showCheckboxes={false}
          deleting={false}
          editing={false}
          adding={false}
          sort="created"
          onRowClick={item =>
            item.audit && history.push(`/history?item=${item.audit.id}&isFromEvent=${item.audit.entity}`)
          }
          version={'2'}
        />
      </Col>
    </Row>

    <Row>
      <Col className="grid-system-margin" />
    </Row>
  </Grid>
);

export default withRouter(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormHistories.tsx